/* eslint-disable react/prop-types */
import React from 'react';
import Dropdown from '../../components/Dropdown';
import SuperTitleHeader from '../../components/DynamicDetailsList/SuperTitleHeader';

export const GreaterOfCustomerPriceRateTestId = 'GreaterOfCustomerPriceRateTestId';
export const GreaterOfSuggestedRetailPriceRateTestId = 'GreaterOfSuggestedRetailPriceRateTestId';
export const FloorPriceOfCustomerPriceRateTestId = 'FloorPriceOfCustomerPriceRateTestId';
export const FloorPriceOfSuggestedRetailPriceRateTestId =
  'FloorPriceOfSuggestedRetailPriceRateTestId';

export const percentOfRoyalty = {
  text: '% of Royalty',
  fields: [
    {
      key: 'percentOfRoyalty',
      name: '% of Royalty',
      props: {
        placeholder: 'Percentage',
        type: 'number',
        inputProps: { min: 0, max: 100 },
      },
    },
  ],
};

const percentageRevenueParam = {
  key: 'percentageRevenue',
  name: '% of Revenue',
  props: {
    placeholder: 'Percentage',
    type: 'number',
    inputProps: { min: 0, max: 100 },
  },
};

export const percentageRevenue = {
  text: '% of Revenue',
  fields: [percentageRevenueParam],
};

const eligibility = [
  {
    key: 'greaterThan30Days',
    text: 'Greater than 30 days',
    value: 30,
    operator: '>',
  },
  {
    key: 'within30Days',
    text: 'Within 30 days',
    value: 30,
    operator: '<=',
  },
];

const eligibilityColumn = {
  key: 'cancellationDaysSincePurchased',
  name: 'Eligibility',
  property: 'cancellationDaysSincePurchased',
  minWidth: 150,
  maxWidth: 200,
  component: Dropdown,
  isResizable: true,
  props: {
    options: eligibility,
    placeholder: 'Select',
  },
  pivotWiderTransformer: dim => {
    return eligibility.find(x => x.value === dim.value && x.operator === dim.operator)?.key;
  },
  transformer: (value, { property }) => {
    return {
      property,
      propertyType: 'computedValue',
      operator: eligibility.find(x => x.key === value).operator,
      value: eligibility.find(x => x.key === value).value,
    };
  },
  styles: {
    gripperBarVerticalStyle: { display: 'none !important' },
  },
};

const remainingValueRateColumn = {
  key: 'percentageRevenue',
  name: 'Rate',
  detailName: '% of Revenue',
  props: {
    placeholder: 'Percentage',
    type: 'number',
    inputProps: { min: 0, max: 100 },
  },
};

const azureInfrastructureListPrice = {
  key: 'azureInfrastructureListPrice',
  name: 'List Price',
  detailName: '% of Azure Infrastructure List Price',
  props: {
    placeholder: 'Percentage',
    type: 'number',
    inputProps: { min: 0, max: 100 },
  },
};

const royaltyFeeRate = {
  key: 'royaltyFeeRate',
  name: 'Royalty Fee Rate',
  detailName: '% of Royalty Fee Rate',
  props: {
    placeholder: 'Percentage',
    type: 'number',
    inputProps: { min: 0, max: 100 },
  },
};

const computeCost = {
  key: 'computeCost',
  name: 'Compute Cost',
  detailName: ' for Compute Cost',
  props: {
    type: 'number',
    inputProps: { min: 0 },
  },
};
const storageCost = {
  key: 'storageCost',
  name: 'Storage Cost',
  detailName: ' for Storage Cost',
  props: {
    type: 'number',
    inputProps: { min: 0 },
  },
};
const percentageFloor = {
  key: 'percentageFloor',
  name: '% of Floor',
  detailName: '% of Floor',
  props: {
    placeholder: 'Percentage',
    type: 'number',
    inputProps: { min: 0, max: 100 },
  },
};

const greaterOfCustomerPriceRateColumn = {
  key: 'customerPriceGreaterOfRate',
  name: 'Customer',
  detailName: '% for Greater of Customer Price',
  property: 'customerPriceGreaterOfRate',
  minWidth: 100,
  maxWidth: 100,
  props: {
    type: 'number',
    'data-testid': GreaterOfCustomerPriceRateTestId,
    inputProps: { min: 0, max: 100 },
  },
  onRenderHeader({ column }) {
    return <SuperTitleHeader title={column.name} superTitle="Greater Of Rates" />;
  },
};

const greaterOfSuggestedRetailPriceRateColumn = {
  key: 'suggestedRetailPriceGreaterOfRate',
  name: 'Alt OpenShift',
  detailName: '% for Greater of Alt OpenShift Price',
  property: 'suggestedRetailPriceGreaterOfRate',
  minWidth: 100,
  maxWidth: 100,
  props: {
    type: 'number',
    'data-testid': GreaterOfSuggestedRetailPriceRateTestId,
    inputProps: { min: 0, max: 100 },
  },
  onRenderHeader({ column }) {
    return <SuperTitleHeader title={column.name} rightPadding={12} />;
  },
};

const floorPriceOfCustomerRateColumn = {
  key: 'customerPriceFloorPriceRate',
  name: 'Customer',
  detailName: '% for Floor Price of Customer Price',
  property: 'customerPriceFloorPriceRate',
  minWidth: 100,
  maxWidth: 100,
  props: {
    type: 'number',
    'data-testid': FloorPriceOfCustomerPriceRateTestId,
    inputProps: { min: 0, max: 100 },
  },
  onRenderHeader({ column }) {
    return <SuperTitleHeader title={column.name} superTitle="Floor Price Rates" />;
  },
};

const floorPriceOfSuggestedRetailPriceRateColumn = {
  key: 'suggestedRetailPriceFloorPriceRate',
  name: 'Alt OpenShift',
  detailName: '% for Floor Price of Alt OpenShift',
  property: 'suggestedRetailPriceFloorPriceRate',
  minWidth: 100,
  maxWidth: 100,
  props: {
    type: 'number',
    'data-testid': FloorPriceOfSuggestedRetailPriceRateTestId,
    inputProps: { min: 0, max: 100 },
  },
  onRenderHeader({ column }) {
    return <SuperTitleHeader title={column.name} rightPadding={12} />;
  },
};

const termDiscount = {
  key: 'termDiscount',
  name: 'Term Discount',
  detailName: '% of Term Discount',
  props: {
    placeholder: 'Percentage',
    type: 'number',
    inputProps: { min: 0, max: 100 },
  },
};

const ProductTier = {
  key: 'productTier',
  name: 'Product Category',
  detailName: 'Product Category',
  props: {
    type: 'text',
    inputProps: {},
  },
};

const companyFee = {
  key: 'companyFee',
  name: 'Company Fee',
  detailName: 'Company Fee',
  props: {
    type: 'text',
    inputProps: {},
  },
};

const secondaryValue = {
  key: 'secondaryValue',
  name: 'Secondary Value',
  detailName: 'Secondary Value',
  props: {
    type: 'text',
    inputProps: {},
  },
};

export const remainingValueReturnProration = {
  text: 'Return Prorated (Days)',
  fields: [remainingValueRateColumn],
};

export const remainingValuePaymentProrated = {
  text: 'Payment Prorated (Days)',
  fields: [remainingValueRateColumn],
};

export const fullReturn = {
  text: 'Full Return',
  fields: [remainingValueRateColumn],
};

const royaltyShare = {
  text: 'Royalty Share',
  calculationMethods: { percentOfRoyalty },
  silos: ['1p-azure', '3p-tla'],
  dimensions: [],
};

const royaltyDiscount = {
  text: 'Royalty Discount',
  calculationMethods: { percentOfRoyalty },
  silos: ['1p-azure', '3p-tla'],
  dimensions: [],
};

const revenueOwnership = {
  text: 'Revenue Ownership',
  calculationMethods: { percentageRevenue },
  silos: ['1p-azure'],
  dimensions: [],
};

const greaterOfCustomerPriceAndFloorPrice = {
  detailName: 'Greater of Customer Price & Floor Price',
  text: 'Greater of Customer Price & Floor Price',
  fields: [],
};

const royaltyOfRevenueDifference = {
  detailName: 'Royalty Of Revenue Difference',
  text: 'Royalty Of Revenue Difference',
  fields: [azureInfrastructureListPrice, royaltyFeeRate],
};
const payGoRevenue = {
  detailName: 'PayGo Revenue',
  text: 'PayGo Revenue',
  fields: [computeCost, storageCost],
};
const reservedInstanceRevenue = {
  detailName: 'Reserved Instance Revenue',
  text: 'Reserved Instance Revenue',
  fields: [computeCost, storageCost],
};
const annualReservedInstanceRevenue = {
  detailName: 'Annual Reserved Instance Revenue',
  text: 'Annual Reserved Instance Revenue',
  fields: [],
};
const quarterlyPayGoRevenue = {
  detailName: 'Quarterly PayGo Revenue',
  text: 'Quarterly PayGo Revenue',
  fields: [percentageRevenueParam],
};
const payGoRoyaltyFloorRevenue = {
  detailName: 'PayGo Royalty Floor Revenue',
  text: 'PayGo Royalty Floor Revenue',
  fields: [percentageFloor, percentageRevenueParam],
};
const sharedCostRevenue = {
  detailName: 'Shared Cost Revenue',
  text: 'Shared Cost Revenue',
  fields: [],
};
const serverlessCostRevenue = {
  detailName: 'Serverless Cost Revenue',
  text: 'Serverless Cost Revenue',
  fields: [],
};
const revenueGreaterThanZero = {
  text: 'Revenue: Greater than zero',
  detailName: 'Revenue Greater than zero',
  fields: [],
};

const chargesDividedByPaidUnits = {
  detailName: 'Charges USD divided Paid Units',
  text: 'Charges USD divided Paid Units',
  fields: [],
};

const greaterOfCustomerPriceAndAltOpenShiftPrice = {
  text: 'Greater of Customer Price & Alt OpenShift',
  fields: [
    greaterOfCustomerPriceRateColumn,
    greaterOfSuggestedRetailPriceRateColumn,
    floorPriceOfCustomerRateColumn,
    floorPriceOfSuggestedRetailPriceRateColumn,
  ],
};

const quantityNegation = {
  detailName: 'Negate the quantity',
  text: 'Negation',
  fields: [],
};

const reservedInstanceCancellation = {
  text: 'Reserved Instance Cancellation',
  note: {
    title: 'Eligibility',
    lines: ['Note: Non-eligible transactions will follow standard return methodology'],
  },
  silos: ['1p-azure'],
  calculationMethods: {
    remainingValueReturnProration,
    remainingValuePaymentProrated,
    fullReturn,
  },
  dimensions: [eligibilityColumn],
};

const greaterOfCustomerPriceAndFloorPriceCalcFeature = {
  text: 'Greater Of Customer Price And Floor Price',
  silos: ['1p-azure'],
  calculationMethods: {
    greaterOfCustomerPriceAndFloorPrice,
  },
};

const revenueDefinition = {
  text: 'Revenue Definition',
  silos: ['1p-azure'],
  calculationMethods: {
    greaterOfCustomerPriceAndFloorPrice,
  },
  dimensions: [],
};

const reservedInstanceDiscountRevenue = {
  detailName: 'Reserved Instance Discount Revenue',
  text: 'Reserved Instance Discount Revenue',
  fields: [ProductTier, termDiscount],
};
const payGoCompanyFeeRevenue = {
  detailName: 'PayGo Company Fee Revenue',
  text: 'PayGo Company Fee Revenue',
  fields: [ProductTier],
};

const reservedInstanceCompanyFee = {
  detailName: 'Reserved Instance Company Fee',
  text: 'Reserved Instance Company Fee',
  fields: [companyFee, secondaryValue],
};
const payGoCompanyFee = {
  detailName: 'PayGo Company Fee',
  text: 'PayGo Company Fee',
  fields: [companyFee, secondaryValue],
};

if (window.config?.enableNetAppCalcMethod) {
  revenueDefinition.calculationMethods.royaltyOfRevenueDifference = royaltyOfRevenueDifference;
}
if (window.config?.enableVmwareCalcMethod) {
  revenueDefinition.calculationMethods.payGoRevenue = payGoRevenue;
  revenueDefinition.calculationMethods.reservedInstanceRevenue = reservedInstanceRevenue;
}

if (window.config?.enableDataBricksCalcMethod) {
  if (window.config?.enableAnnualReservedInstance)
    revenueDefinition.calculationMethods.annualReservedInstanceRevenue =
      annualReservedInstanceRevenue;
  if (window.config?.enablePayGoRevenue) {
    revenueDefinition.calculationMethods.quarterlyPayGoRevenue = quarterlyPayGoRevenue;
    revenueDefinition.calculationMethods.payGoRoyaltyFloorRevenue = payGoRoyaltyFloorRevenue;
  }
  if (window.config?.enableSharedCostRevenue)
    revenueDefinition.calculationMethods.sharedCostRevenue = sharedCostRevenue;
  if (window.config?.enableServerlessCostRevenue)
    revenueDefinition.calculationMethods.serverlessCostRevenue = serverlessCostRevenue;
}

const creditOffer = {
  text: 'Credit Offer',
  silos: ['1p-azure'],
  calculationMethods: {
    revenueGreaterThanZero,
  },
};

const customerPrice = {
  text: 'Customer Price',
  silos: ['1p-azure'],
  calculationMethods: {
    chargesDividedByPaidUnits,
  },
};

const floorPrice = {
  text: 'Floor Price',
  silos: ['1p-azure'],
  calculationMethods: {
    greaterOfCustomerPriceAndAltOpenShiftPrice,
  },
  dimensions: [],
};

const quantityDefinition = {
  text: 'Quantity Definition',
  silos: ['1p-azure'],
  calculationMethods: {
    quantityNegation,
  },
  dimensions: [],
};

const productTierMapping = {
  text: 'Product Category Mapping',
  silos: ['1p-azure'],
  calculationMethods: {
    payGoCompanyFeeRevenue,
    reservedInstanceDiscountRevenue,
  },
  dimensions: [],
};

const companyFeeMapping = {
  text: 'Company Fee Mapping',
  silos: ['1p-azure'],
  calculationMethods: {
    payGoCompanyFee,
    reservedInstanceCompanyFee,
  },
  dimensions: [],
};

export const calcFeatureTypes = {
  royaltyShare,
  royaltyDiscount,
  ...(window.config?.enableRevenueOwnership && { revenueOwnership }),
};

if (window.config?.enableReservedInstances) {
  calcFeatureTypes.reservedInstanceCancellation = reservedInstanceCancellation;
  calcFeatureTypes.revenueDefinition = revenueDefinition;
  calcFeatureTypes.creditOffer = creditOffer;
  calcFeatureTypes.customerPrice = customerPrice;
  calcFeatureTypes.floorPrice = floorPrice;
  calcFeatureTypes.greaterOfCustomerPriceAndFloorPrice =
    greaterOfCustomerPriceAndFloorPriceCalcFeature;
  calcFeatureTypes.quantityDefinition = quantityDefinition;
  calcFeatureTypes.productTierMapping = productTierMapping;
  calcFeatureTypes.companyFeeMapping = companyFeeMapping;
}

export const calculationMethods = Object.values(calcFeatureTypes).reduce(
  (values, calcFeature) => ({
    ...values,
    ...calcFeature.calculationMethods,
  }),
  {},
);
